import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CountryDto, ContinentDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss']
})
export class CountryComponent implements OnChanges {

  @Input() countries: CountryDto[];
  @Input() continents: ContinentDto[];
  countryForm: FormGroup;
  countryFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<CountryDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredCountry: Array<any> = [];
  status: boolean;
  selectedCountryId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    
    this.createCountryForm();

  }

  createCountryForm() {
    this.countryFormArray = this.fb.group({ Countries: this.fb.array([]) });
    this.countryForm = this.fb.group({
      CountryName: ['', Validators.required],
        ContinentId: this.selectedCountryId,
        id: null
    });
  }


  // method to display companies
  setCountry() {
    const control = this.countryFormArray.controls.Countries as FormArray;
    this.filteredCountry.forEach((e) => {
      control.push(
        this.fb.group({
          CountryName: e.CountryName,
          ContinentId: e.ContinentId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addCountry(country: CountryDto) {
    console.log('country');
    const control = this.countryFormArray.controls.Countries as FormArray;
    control.insert(
      0,
      this.fb.group({
        CountryName: country.CountryName,
        ContinentId: this.selectedCountryId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.countryFormArray.controls.Countries as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter country
  selectContinent(event: string) {
    this.filteredCountry = this.countries.filter((s) => s.ContinentId === event);
    this.selectedCountryId = event;
    const control = this.countryFormArray.controls.Countries as FormArray;

    if (this.filteredCountry.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setCountry();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteCountry(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.countryFormArray.controls.Countries as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.countries.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.countries[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: CountryDto) {
    if(this.countryForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.countryFormArray.get('Countries')['controls'][this.selectedIndex].patchValue({CountryName: formValue.CountryName});
    } else {
      this.addCountry(formValue);
    }
    this.selectedIndex = null;
    this.countryForm.reset()
  }

  onEdit(index, value: CountryDto) {
    this.selectedIndex = index;
    this.countryForm.patchValue({CountryName: value.CountryName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.countryForm.reset();
  }


  onSubmit(formValue: any) {
    formValue.type = 'country';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('country');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
